import React from "react"
import Icon from "../elements/Icon"
import classnames from "classnames"
import { debounce } from "lodash/function"
import {
  injectIntl,
  defineMessages,
  FormattedMessage,
  FormattedHTMLMessage
} from "react-intl"
import { default as articleMessages } from "../../messages/article"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import settingsMessages from "../../messages/settings"

class ChooseContentType extends React.Component {
  constructor(props) {
    super(props)
    this.state = { expanded: false }
    this.closeTimeout = null

    this.closeExpand = debounce(
      () =>
        this.setState({
          expanded: false
        }),
      1000
    )
  }

  rowButtons = (idx, isLast, expanded) => (
    <div key={"add-at" + idx} style={getStyles("c-buttons__container")}>
      {getStyleTag("button-toolchest")}
      <div
        className={classnames("button-toolchest", {
          "state-open": expanded,
          "button-toolchest--small": !isLast
        })}
      >
        <button
          onClick={e => {
            e.preventDefault()
            this.setState({
              expanded: !this.state.expanded
            })
          }}
          style={getStyles([
            "c-button__new",
            expanded && "c-button__new-hidden"
          ])}
        >
          <span style={getStyles(["c-button__icon", "c-icon__add"])}>
            <Icon icon="plus" />
          </span>
          <FormattedMessage {...articleMessages.addElement} />
        </button>
        <div
          style={getStyles([
            "c-buttons__row",
            expanded && "c-buttons__row-open"
          ])}
        >
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddText(idx)
            }}
            title="Add Text"
          >
            <button style={getStyles(["c-button__icon", "with-margin"])}>
              <Icon icon="text" style={getStyles("c-icon")} />
            </button>
          </div>
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddMedia(idx, "image")
            }}
            title="Add Image"
          >
            <button style={getStyles(["c-button__icon", "with-margin"])}>
              <Icon icon="picture" style={getStyles("c-icon")} />
            </button>
          </div>
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddMedia(idx, "video")
            }}
            title="Add Video"
          >
            <button style={getStyles(["c-button__icon", "with-margin"])}>
              <Icon icon="video" style={getStyles("c-icon")} />
            </button>
          </div>
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddMedia(idx, "audio")
            }}
            title="Add Audio"
          >
            <button style={getStyles(["c-button__icon", "with-margin"])}>
              <Icon icon="audio" style={getStyles("c-icon")} />
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  circledButtons = (idx, isLast, expanded) => (
    <div
      key={"add-at" + idx}
      className={classnames("c-create__add", {
        "c-create__add--small": !isLast
      })}
    >
      {getStyleTag([
        "button-toolchest__button",
        "button-toolchest__item__icon"
      ])}
      <div
        className={classnames("button-toolchest", {
          "state-open": expanded,
          "button-toolchest--small": !isLast
        })}
      >
        <button
          className="button button-toolchest__trigger"
          onClick={e => {
            e.preventDefault()
            this.setState({
              expanded: !this.state.expanded
            })
          }}
        >
          <span className="button__text">
            <FormattedMessage {...articleMessages.add} />
          </span>
          <br />
          <Icon icon="plus" />
        </button>
        <div className="button-toolchest__chest">
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddText(idx)
            }}
            className="button-toolchest__item button-toolchest__item--d0 button-toolchest__item--l1"
            title="Add Text"
          >
            <button className="button">
              <Icon icon="text" />
            </button>
            <br />
            <span className="button__text">
              <FormattedMessage {...articleMessages.addText} />
            </span>
          </div>
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddMedia(idx, "image")
            }}
            className="button-toolchest__item button-toolchest__item--d1 button-toolchest__item--l0"
            title="Add Image"
          >
            <button className="button">
              <Icon icon="picture" />
            </button>
            <br />
            <span className="button__text">
              <FormattedMessage {...articleMessages.addImage} />
            </span>
          </div>
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddMedia(idx, "video")
            }}
            className="button-toolchest__item button-toolchest__item--d1 button-toolchest__item--r0"
            title="Add Video"
          >
            <button className="button">
              <Icon icon="video" />
            </button>
            <br />
            <span className="button__text">
              <FormattedMessage {...articleMessages.addVideo} />
            </span>
          </div>
          <div
            onClick={e => {
              e.preventDefault()
              this._handleAddMedia(idx, "audio")
            }}
            className="button-toolchest__item button-toolchest__item--d0 button-toolchest__item--r1"
            title="Add Audio"
          >
            <button className="button">
              <Icon icon="audio" />
            </button>
            <br />
            <span className="button__text">
              <FormattedMessage {...articleMessages.addAudio} />
            </span>
          </div>
        </div>
      </div>
    </div>
  )

  render() {
    const { idx, isLast, intl } = this.props

    const expanded = this.state.expanded
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    return (
      <div
        onMouseLeave={this.closeExpand}
        onMouseEnter={this.closeExpand.cancel}
        className="clearfix"
      >
        {accountSettings.settings.style.content == "type1"
          ? this.rowButtons(idx, isLast, expanded)
          : this.circledButtons(idx, isLast, expanded)}
        {isLast && (
          <div className="row column">
            <p className="text-center">
              <em>
                <FormattedHTMLMessage {...articleMessages.tip} />
              </em>
            </p>
          </div>
        )}
      </div>
    )
  }

  _handleAddText(idx) {
    if (this.props.handleAddText) {
      this.props.handleAddText(this.props.idx)
    }

    setTimeout(() => this.setState({ expanded: false }), 500)
  }

  _handleAddMedia(idx, type) {
    if (this.props.handleAddMedia) {
      this.props.handleAddMedia(this.props.idx, type)
    }

    setTimeout(() => this.setState({ expanded: false }), 500)
  }
}

export default injectIntl(ChooseContentType)



// WEBPACK FOOTER //
// ./webapp/components/modules/ChooseContentType.js